import { render } from "./SnakeDetail.vue?vue&type=template&id=3504284e"
import script from "./SnakeDetail.vue?vue&type=script&lang=js"
export * from "./SnakeDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/madoka.igarashi/Projects/lil/lil-log-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__